import React from "react";
import { makeStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select, { SelectProps } from "@material-ui/core/Select";
import createStyles from "@material-ui/styles/createStyles/createStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import { tesaDarkRedError } from "../../styles/colors";
import CustomErrorIcon from "../../assets/icons/CustomErrorIcon";

export interface CustomDropdownProps extends SelectProps {
  helperText?: string;
  labelText: string;
  mandatory?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    error: {
      color: tesaDarkRedError,
    },
    formControl: {
      alignSelf: "flex-start",
      display: "flex",
    },
  }),
);

const CustomDropdown = (props: CustomDropdownProps): JSX.Element => {
  const classes = useStyles(props);
  const {
    autoFocus,
    children,
    disabled,
    error,
    fullWidth,
    helperText,
    labelText,
    mandatory,
    name,
    onChange,
    value,
    ...SelectProps
  } = props;
  const shrinkDisplayEmpty = SelectProps.displayEmpty && value != null;
  const shrink = SelectProps.multiple && Array.isArray(value) ? value.length > 0 : !!value;
  const shouldShrink = shrinkDisplayEmpty || shrink;

  return (
    <FormControl fullWidth={fullWidth} variant="filled" className={classes.formControl}>
      <InputLabel disabled={disabled} error={error} id="select-filled-label" shrink={shouldShrink}>
        {mandatory ? `${labelText}*` : labelText}
      </InputLabel>
      <Select
        autoFocus={autoFocus}
        disabled={disabled}
        error={error}
        labelId="select-filled-label"
        IconComponent={error ? CustomErrorIcon : ExpandMoreIcon}
        id="demo-simple-select-filled"
        MenuProps={{
          variant: "menu",
        }}
        name={name}
        value={value}
        variant="outlined"
        onChange={onChange}
        {...SelectProps}
      >
        {children}
      </Select>
      <FormHelperText disabled={disabled} error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default CustomDropdown;
